import React from 'react'

const Performance = () => {
  return (
    <div>
      <p>performance</p>
    </div>
  )
}

export default Performance
